

const dataRoadMap = [

    {
        id: 1,
        time: 'Q1 - 2024',
        title: 'Q1 - 2024',
        desc: `
• Platform Brainstorming <br/>
• Website Building <br/>
• Feature Development <br/>
        `,
        class: ''
    },
    {
        id: 2,
        time: 'Q2 - 2024',
        title: 'Q2 - 2024',
        desc: `• Platform Testing <br/> • Pre-Launch Marketing <br/>• Social Media Creation`,
        class: 'right'
    },

    {
        id: 3,
        time: 'Q3 - 2024',
        title: 'Q3 - 2024',
        desc: `• Release GMGN Platform
<br/> • Marketing Campaign
<br/> • Socials Community Building
<br> • Partnership
<br/> • Events And Airdrop
<br/> • Optimize GMGN Platform`,
        class: ''
    },

    {
        id: 4,
        time: 'Q4 - 2024',
        title: 'Q4 - 2024',
        desc: `• GMGN On Multi-Chain <br/>
• Airdrop Campaign <br/>
• Complete Feature Ecosystem <br/>
• More Marketing Campaign <br/>
• Big Partnership`,
        class: 'right'
    },
    {
        id: 5,
        time: 'Q1 - 2025',
        title: 'Q1 - 2025',
        desc: `• GMGN Version 2.0 <br/>
• Airdrop To 10,000 Users <br/>
• Solana NFT Support`,
        class: ''
    },
    {
        id: 6,
        time: 'Q2 - 2025',
        title: 'Q2 - 2025',
        desc: `• GMGN Token Plan <br/>
• Multichain NFT Support <br/>
• 100+ Partnerships`,
        class: 'right'
    },



]

export default dataRoadMap;